module.exports = __webpack_public_path__ + "img/qinghua.23b39b97.png";